import dioramasConfig from '../../../../configs/dioramasConfig.json';
import type { DioramaConfig } from './dioramaState';

export const dioramaConfigs: DioramaConfig[] = dioramasConfig;
